module.exports = __webpack_public_path__ + "static/media/banner-t&a.c3ddb294.jpg";